import React, { useState } from 'react';
import styled from 'styled-components';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQContainer = styled.section`
  padding: 80px 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const FAQItem = styled.div`
  background: white;
  border-radius: 15px;
  margin-bottom: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  overflow: hidden;
`;

const FAQQuestion = styled.button`
  width: 100%;
  padding: 25px 30px;
  background: none;
  border: none;
  text-align: left;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;
  
  &:hover {
    background: #f8fafc;
  }
`;

const FAQAnswer = styled.div`
  max-height: ${props => props.isOpen ? '500px' : '0'};
  padding: ${props => props.isOpen ? '0 30px 25px' : '0 30px 0'};
  color: #666;
  line-height: 1.6;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };

  const faqs = [
    {
      question: "What is InitX Technologies and how does it work?",
      answer: "InitX Technologies is an IT consulting and software development company offering web development, software development, AI solutions, cloud services, and end-to-end digital transformation for startups and enterprises. We work closely with businesses to understand their needs and deliver custom technology solutions that drive growth and innovation."
    },
    {
      question: "How much do InitX services cost?",
      answer: "Our pricing varies based on project scope, complexity, and requirements. We offer competitive rates for web development, mobile apps, AI solutions, and consulting services. Contact us for a free consultation and customized quote tailored to your specific needs."
    },
    {
      question: "Can I collaborate with InitX team during development?",
      answer: "Absolutely! We believe in transparent collaboration throughout the development process. You'll have regular updates, milestone reviews, and direct communication with our development team to ensure your project meets your exact requirements."
    },
    {
      question: "Is my project data secure with InitX?",
      answer: "Yes, security is our top priority. We implement enterprise-grade security measures including encrypted communications, secure development practices, and strict confidentiality agreements. Your business data and intellectual property are fully protected."
    },
    {
      question: "Can I customize my solution after delivery?",
      answer: "Yes, all our solutions are built with scalability and customization in mind. We provide ongoing support and maintenance services, and can easily modify or enhance your solution as your business grows and requirements evolve."
    },
    {
      question: "Do you offer ongoing support after project completion?",
      answer: "Yes, we provide comprehensive post-launch support including maintenance, updates, bug fixes, and technical assistance. We offer various support packages to ensure your solution continues to perform optimally and stays up-to-date with latest technologies."
    }
  ];

  return (
    <FAQContainer>
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <h2 style={{ 
          fontSize: '2.5rem', 
          marginBottom: '20px', 
          color: '#ffffff',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>
          Frequently Asked Questions
        </h2>
        <p style={{ 
          fontSize: '1.2rem', 
          color: '#ffffff',
          opacity: '0.9'
        }}>
          Find answers to common questions about InitX Technologies
        </p>
      </div>

      {faqs.map((faq, index) => (
        <FAQItem key={index}>
          <FAQQuestion onClick={() => toggleItem(index)}>
            {faq.question}
            {openItems.has(index) ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
          </FAQQuestion>
          
          <FAQAnswer isOpen={openItems.has(index)}>
            {faq.answer}
          </FAQAnswer>
        </FAQItem>
      ))}
    </FAQContainer>
  );
};

export default FAQ;